export default __webpack_public_path__ + "static/popbubble-b04fc710ceefadd0aa781a4beaee155e.gif";